import React from 'react';

interface PaymentFailedScreenProps {
  onChangeView: (view: string) => void;
}

export const PaymentFailedScreen: React.FC<PaymentFailedScreenProps> = ({ onChangeView }) => {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(13,17,23,.97)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, zIndex: 9999,
    }}>
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--red-border)',
        borderRadius: 16,
        maxWidth: 480, width: '100%',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,.6)',
        textAlign: 'center',
      }}>
        {/* Header */}
        <div style={{
          padding: '32px 32px 24px',
          background: 'rgba(248,81,73,.06)',
          borderBottom: '1px solid var(--border)',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: 16,
            background: 'var(--red-dim)', border: '1px solid var(--red-border)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <svg width="28" height="28" fill="none" stroke="var(--red)" strokeWidth="1.5" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
            Falha no pagamento
          </h2>
          <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7 }}>
            Não conseguimos processar o pagamento da sua assinatura.
            Isso pode acontecer por saldo insuficiente, cartão expirado
            ou dados desatualizados.
          </p>
        </div>

        {/* Corpo */}
        <div style={{ padding: '24px 32px' }}>

          {/* O que fazer */}
          <div style={{
            background: 'var(--bg3)', border: '1px solid var(--border)',
            borderRadius: 10, padding: '16px', marginBottom: 20, textAlign: 'left',
          }}>
            <p style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted2)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 12 }}>
              O que fazer agora
            </p>
            {[
              { icon: '💳', text: 'Verifique se o cartão cadastrado está válido e com limite disponível' },
              { icon: '🏦', text: 'Confirme se há saldo suficiente na conta para débito automático' },
              { icon: '🔄', text: 'Assine novamente com um novo método de pagamento' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>{item.icon}</span>
                <span style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.5 }}>{item.text}</span>
              </div>
            ))}
          </div>

          {/* Aviso sobre dados */}
          <div style={{
            background: 'rgba(56,139,253,.08)', border: '1px solid var(--blue-border)',
            borderRadius: 8, padding: '12px 14px', marginBottom: 20,
            fontSize: 12, color: 'var(--blue)', lineHeight: 1.6, textAlign: 'left',
          }}>
            ✓ Seus dados estão preservados. Assim que o pagamento for confirmado,
            o acesso é restaurado automaticamente.
          </div>

          {/* CTA */}
          <button
            onClick={() => onChangeView('PAYMENT')}
            style={{
              width: '100%', padding: '14px',
              borderRadius: 8, fontSize: 14, fontWeight: 600,
              cursor: 'pointer', border: 'none',
              background: 'var(--blue)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              marginBottom: 10,
            }}
          >
            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
            Atualizar método de pagamento
          </button>

          <p style={{ fontSize: 11, color: 'var(--muted2)', lineHeight: 1.6 }}>
            O Mercado Pago pode realizar novas tentativas automáticas de cobrança.
            Caso queira garantir o acesso agora, assine novamente com outro método.
          </p>
        </div>
      </div>
    </div>
  );
};
